var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.otazka.moznosti, function(moznost, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "custom-control custom-radio",
          class: {
            "image-radio":
              _vm.isImage(moznost.subor) || _vm.isVideo(moznost.subor),
            "zvuk-radio": _vm.isAudio(moznost.subor),
            valid:
              _vm.showResult && moznost.label === _vm.otazka.spravna_odpoved,
            invalid:
              _vm.showResult &&
              moznost.label !== _vm.otazka.spravna_odpoved &&
              _vm.odpoved.input === moznost.label
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.odpoved.input,
                expression: "odpoved.input"
              }
            ],
            staticClass: "custom-control-input",
            attrs: {
              type: "radio",
              id: moznost.label,
              name: moznost.label,
              disabled: _vm.showResult
            },
            domProps: {
              value: moznost.label,
              checked: _vm._q(_vm.odpoved.input, moznost.label)
            },
            on: {
              change: function($event) {
                return _vm.$set(_vm.odpoved, "input", moznost.label)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom-control-label",
              attrs: { for: moznost.label }
            },
            [
              _vm.isImage(moznost.subor)
                ? [
                    _c("img", {
                      attrs: { src: _vm.skolyStorage + moznost.subor, alt: "" }
                    })
                  ]
                : _vm.isVideo(moznost.subor)
                ? [
                    _c("skoly-ulohy-kvizova-otazka-video-thumbnail", {
                      attrs: { subor: moznost.subor }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "play-btn",
                        on: {
                          click: function($event) {
                            return _vm.showVideo(moznost.subor)
                          }
                        }
                      },
                      [_c("span", { staticClass: "icon icon--play" })]
                    )
                  ]
                : _vm.isAudio(moznost.subor)
                ? [
                    _c("p", { staticClass: "text-21 mb-15" }, [
                      _vm._v(_vm._s(moznost.hodnota))
                    ]),
                    _vm._v(" "),
                    _c("skoly-ulohy-kvizova-otazka-audio", {
                      attrs: { subor: moznost.subor }
                    })
                  ]
                : [
                    _vm._v(
                      "\n                " +
                        _vm._s(moznost.hodnota) +
                        "\n            "
                    )
                  ]
            ],
            2
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }